import { PureComponent } from "react";
import Image from "react-simple-image";

import * as Routes from "../../generated/routes";
import { UserAvatarQueryFragmentFragmentDoc } from "../../generated/schema";
import { firstFragmentName } from "../../utils/firstFragmentName";
import { Link } from "../Link";

export type SizeType = "xsmall" | "small" | "medium" | "large";

export const UserAvatarQueryFragmentName = firstFragmentName(UserAvatarQueryFragmentFragmentDoc);
export const UserAvatarQueryFragment = UserAvatarQueryFragmentFragmentDoc;

export type UserType = Readonly<{
  // either account or path is required (account is just for backward compatibility)
  account?: string | null;
  path?: string | null;
  avatar1x: {
    url: string;
  };
  avatar2x: {
    url: string;
  };
}>;

type Props = Readonly<{
  user: UserType;
  size: SizeType;
  isLink?: boolean;
  additionalClass?: string;
  target?: "_blank";
}>;

export class UserAvatar extends PureComponent<Props> {
  static readonly defaultProps = {
    isLink: true,
    additionalClass: "",
  };

  renderAvatar() {
    const user = this.props.user;
    return (
      <Image
        srcSet={{ "1x": user.avatar1x.url, "2x": user.avatar2x.url }}
        src={user.avatar1x.url}
        alt=""
        className={`avatar is-avatar-${this.props.size} ${this.props.additionalClass}`}
      />
    );
  }

  render() {
    if (this.props.isLink) {
      return (
        <Link
          to={this.props.user.path || Routes.friendlyUserPath(this.props.user.account!)}
          className={`userAvatar is-${this.props.size}`}
          target={this.props.target}
        >
          {this.renderAvatar()}
        </Link>
      );
    } else {
      return <span className={`userAvatar is-${this.props.size}`}>{this.renderAvatar()}</span>;
    }
  }
}
